import * as bc from 'lib0/broadcastchannel';
import { useEffect } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import type { UserRecent, UserRecentRegister } from 'src/hooks/recents';
import { useRecentStore } from 'src/hooks/recents';
import { useUserRecentsPersistance } from './useUserRecentsPersistance';

type RecentAddProps = Pick<
  UserRecent,
  'title' | 'feature' | 'objectRef' | 'icon'
> & {
  url?: string;
};

export const useRecentRegister = (
  props?: RecentAddProps,
): UserRecentRegister => {
  const { user } = useAuthContext();
  const { addUserRecent, removeUserRecent } = useUserRecentsPersistance();
  const { addRecent, removeRecent } = useRecentStore((state) => ({
    addRecent: state.addRecent,
    removeRecent: state.removeRecent,
  }));

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!props?.feature) return;
    const payload = { ...props, url: props?.url || location.pathname };
    addUserRecent(payload).then((recent) =>
      addRecent(user?.workspace?._id || '', user?._id || '', recent),
    );
  }, [location.pathname]);

  useEffect(() => {
    const sub = bc.subscribe('remove-recent', (data: any) => {
      removeRecent(user?.workspace?._id || '', user?._id || '', data.RecentId);
    });

    return () => {
      bc.unsubscribe('remove-recent', sub);
    };
  }, [removeRecent, user]);

  return {
    addRecent: async (recent: Partial<UserRecent>) => {
      addRecent(user?.workspace?._id || '', user?._id || '', recent);
      await addUserRecent({
        ...recent,
        url: `chat/${recent.objectRef || ''}`,
      });
    },
    removeRecent: async (id: string) => {
      removeRecent(user?.workspace?._id || '', user?._id || '', id);
      await removeUserRecent(id);
      bc.publish('remove-recent', { recentId: id });
    },
  };
};
